import React, { useEffect } from "react";
import style from "./style.module.css";
import CartNull from "./components/CartNull";
import Cart from "./components/Cart";
import CartHeader from "./components/CartHeader";
import CartLoader from "./components/CartLoader";
import FromToPage from "../../components/FromToPage";
import { useDispatch, useSelector } from "react-redux";
import { getCartPageProducts } from "../../store/MainSlice";
import lang from "../../lang/lang";
import PageSeo from "../../components/PageSeo";

const CartContent = () => {

  const { cartPageProducts, currentLanguage,isLoading, shopCartCount } = useSelector(({ main }) => main);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCartPageProducts());
  }, []); 
    
  return (
    <>
      <PageSeo pageKey="cart" />
      <div className={style.cart_content}>
        <CartHeader />
        <div
          className="wrapper"
          style={{ marginBottom: 0 }}>
          <div className={style.cart_main}>
            <FromToPage
              langs={currentLanguage}
              pages={[{ label: lang[currentLanguage]?.cart, active: true }]}
            />
            <h1 style={{ margin: "0 0 16px", fontSize: "24px" }}>
              {lang[currentLanguage]?.cart}
            </h1>
            {!isLoading ? (
              <CartLoader />
            ) : !cartPageProducts?.cart?.length ? (
              <CartNull />
            ) : (
              <Cart />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CartContent;
